import { utcToZonedTime } from 'date-fns-tz';

/**
 * The local time zone of the current user
 */

export var userLocalTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export function getMidnightLocalDateTimeFromDateString(date) {
  return new Date("".concat(date, "T00:00:00"));
}

/**
 * Get the today date considering a given timezone
 */

export function getZonedTodayDate(timezone) {
  var todayDate = new Date();
  // Today date is the "today" based on the selected timezone for the nudge
  // Fallback to UTC if no timezone is set
  var zonedTodayDate = utcToZonedTime(todayDate, timezone || 'UTC');
  return zonedTodayDate;
}

/**
 * Returns a selected date and the zoned today date based on a timezone and a date string.
 * The returned values are `Date` in order to be used by the `DatePicker` component.
 *
 */

export function getSelectedAndTodayDate(date, timezone) {
  // "today" based on the provided timezone.
  var zonedTodayDate = getZonedTodayDate(timezone);

  // Get the selected date using either the provided date or the zoned today date.
  var selectedDate = date ? getMidnightLocalDateTimeFromDateString(date) : zonedTodayDate;
  return {
    selectedDate: selectedDate,
    zonedTodayDate: zonedTodayDate
  };
}